import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class DeviceService {

    private baseUrl: string;
    constructor(
        private http: HttpClient
    ) {
        this.baseUrl = environment.baseUrl
    }

    changeDeviceAlias(spotId, spotName, newName) {
        const query = {
            messengerId: spotId,
            messengerName: spotName,
            aliasName: newName
        }
        return this.http.put(this.baseUrl + '/device/' + spotName, query);
    }
}